<template>
    <Link :href="route('groups.view', data.tra_id)" class="text-blue-600">{{
        data.title
    }}</Link>
</template>

<script>
export default {
    name: "GroupTableTitle",
    components: { },
    data() {
        return {};
    },
    methods: {},
    props: {
        meta: {
            type: Object,
            default: () => {}
        },
        name: {
            type: String,
            default: ""
        },
        data: {
            type: Object,
            default: () => {}
        }
    }
};
</script>

<style scoped></style>
